<body>
  <div class="main">
    <div class="grid-overlay">
      <div class="nav">
        <a href="/">{{ 'login.nav.back' | translate }}</a>
      </div>
      <div class="logoblock"><img (click)="goHome()" src="../../assets/images/BRAND.png" alt="Logo Billcentrix">
        <h2>{{ 'createAccount.title' | translate }}</h2>
      </div>


      <div class="background-white">
        <!-- Título principal -->
        <div class="header-section">
          <h1>{{ 'createAccount.heading' | translate }}</h1>
          <p class="subtitle">{{ 'createAccount.subtitle' | translate }}</p>
        </div>

        <!-- Botón de Google usando el componente de la librería (igual que en login) -->
        <div class="google-signin-section">
          <asl-google-signin-button
            type="standard"
            size="large"
            text="signup_with">
          </asl-google-signin-button>
        </div>

        <!-- Separador -->
        <div class="separator">
          <span>{{ 'createAccount.separator' | translate }}</span>
        </div>

        <!-- Formulario tradicional -->
        <form class="user" [formGroup]="signUpForm">
          <div class="form-group">
            <label for="exampleInputEmail">{{ 'createAccount.form.emailLabel' | translate }}</label>
            <input type="email"
              [placeholder]="'createAccount.form.emailPlaceholder' | translate"
              formControlName="email"
              id="exampleInputEmail"
              class="form-input">
              @if (signUpForm.get('email')?.hasError('required') && signUpForm.get('email')?.touched) {
                <small
                class="form-error-msg">{{ 'createAccount.form.emailRequired' | translate }}</small>
              }
              @if (signUpForm.get('email')?.hasError('email') && signUpForm.get('email')?.touched) {
                <small
                class="form-error-msg">{{ 'createAccount.form.emailInvalid' | translate }}</small>
              }
            </div>

            <div class="options">
              <button class="crear"
                type="button"
                (click)="singUp()"
                [disabled]="signUpForm.invalid">
                {{ 'createAccount.form.submit' | translate }}
              </button>
            </div>
          </form>

          <!-- Link al login -->
          <div class="logear">
            {{ 'createAccount.existingAccount.question' | translate }}
            <button (click)="onLoginClick()">{{ 'createAccount.existingAccount.login' | translate }}</button>
          </div>

        </div>
      </div>

    </div>
    <app-footer></app-footer>





